import styled from 'styled-components';

export const DescriptionImage = ({
  description_image,
}: {
  description_image: string;
}): JSX.Element => {
  return (
    <StyledDescriptionImage>
      <a href={description_image} target='_blank' rel='noopener noreferrer'>
        <img src={description_image} alt={'description image'} />
      </a>
    </StyledDescriptionImage>
  );
};

const StyledDescriptionImage = styled.div`
  display: inline-block;
  position: relative;
  height: 226px;
  border-radius: 4.13296px;
  margin-bottom: 10px;
  cursor: pointer;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 576px) {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;
